import { ApiService } from '../shared/services/api-service/api.service';
import { IAbandonmentPayload } from './interfaces/abandonment.interfaces';

class AbandonmentServiceClass {
    private static _instance: AbandonmentServiceClass;
    public static get instance() {
        return this._instance || (this._instance = new this());
    }
    private constructor() { }

    /**
     * Method to save abandonment
     * @param payload
     */
    async saveAbandonment(payload: IAbandonmentPayload) {
        try {
            return await ApiService.saveAbandonment(payload);
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const AbandonmentService = AbandonmentServiceClass.instance;
